// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// ✅ Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyAGzyIeA4dlkPKM25Y3V1USUKDGdTUlpYk",
    authDomain: "theravandemo.firebaseapp.com",
    projectId: "theravandemo",
    storageBucket: "theravandemo.appspot.com",
    messagingSenderId: "39485260246",
    appId: "1:39485260246:web:8b674889a86972c29fe477"
};

// ✅ Initialize Firebase App
const app = initializeApp(firebaseConfig);

// ✅ Export common Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

// 👉 你之後可以加呢啲 if needed:
// import { getStorage } from "firebase/storage";
// export const storage = getStorage(app);

